import { t } from '@hefe/i18n';
import { BasketballTeam } from '@hefe/models';
import { Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

interface TeamPracticeTimesComponentProps {
  team: BasketballTeam;
}

export default function TeamPracticeTimesComponent(
  props: TeamPracticeTimesComponentProps
) {
  const navigate = useNavigate();

  return (
    <Space direction="vertical" size="large">
      <Typography.Paragraph>
        {t('practices.administration.practice_times.new_feature_info')}
      </Typography.Paragraph>
      <Typography.Link onClick={() => navigate('/season/practices')}>
        {t('practices.administration.title')}
      </Typography.Link>
    </Space>
  );
}
